import z from 'zod';

export const ThirdPartyCredentialsSchema = z.object({
  sharepoint: z
    .object({
      tenantId: z.string(),
      clientId: z.string(),
      clientSecret: z.string(),
      siteId: z.string(),
    })
    .optional(),
  emailStudio: z
    .object({
      tenantId: z.uuid(),
      clientId: z.string(),
      clientSecret: z.string(),
    })
    .partial()
    .optional(),
});

export const ThirdPartySettings = z.object({
  sharepoint: z
    .object({
      filterByCAOField: z.string().optional(),
      // * When true, all document libraries on the site are traversed instead of only the default drive.
      // * Set directly in MongoDB per company — currently used for Longfonds only.
      scanAllDrives: z.boolean().optional(),
    })
    .optional(),
  // * Set directly in MongoDB per company, the same way as `sharepoint`.
  topdesk: z
    .object({
      // * The TopDesk (category, subcategory) pairs the Article Architect
      // * backfill keeps. An absent or empty list means no backfill scope, and
      // * the backfill refuses to run.
      backfillPairs: z
        .array(
          z.object({
            category: z.string().optional(),
            subcategory: z.string().optional(),
          }),
        )
        .optional(),
      // * The ISO date the manual TopDesk pull starts from. Absent means the
      // * backend default start date.
      backfillSince: z.string().optional(),
      // * When true, the LLM classifier judges every ticket the not-a-problem
      // * title patterns keep, so it can only add drops. Absent means off.
      backfillClassifierEnabled: z.boolean().optional(),
      // * Regex sources of the not-a-problem titles, matched case-insensitive
      // * against the trimmed title. Absent means the backend default list; an
      // * empty list means no patterns.
      notAProblemTitlePatterns: z.array(z.string()).optional(),
    })
    .optional(),
});
